
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class CurrentRouteService {

  constructor() { }

  private currentrouteAnnouncedSource = new Subject<string>();
  // Observable string streams
  currentrouteAnnounced$ = this.currentrouteAnnouncedSource.asObservable();
  // Service message commands
  announceCurrentRoute(currentroute: string) {
    this.currentrouteAnnouncedSource.next(currentroute);
  }

} 